

import { collapseAllExpandedRowsContextMenuObject } from "@/components/widgets/tradeActionSummary/contextMenusRightClick/genericContextMenuItems";
import {
  deleteBlockFromContextActions,
  splitBlocksSERVICE,
  updateBlockStatusFromContextActions,
} from "@/services/CreationTableSERVICES";
import { saveTradeAction } from "@/store/importBlocksAndAllocationsStoreACTIONS";
import { clearAllGridFilters } from "@/lib/agGridFilterHelper";
import {
  DetailGridInfo,
  GetContextMenuItemsParams,
  IRowNode,
  MenuItemDef,
  RowSelectedEvent,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { Dispatch, SetStateAction } from "react";
import { toast } from "react-toastify";
import {
  IblocksRecreateJSONToSend,
  IRecreateBlock,
} from "./creationInterfaces";
import tradeCreationInProcessStore from "@/store/tradeCreationInProcessStore";
import useTableUIStore from "@/store/tableUIStore";
import { clearFilters } from "@/components/icons/SVGIcons";

// custom helper functions:

export const getDetailRowHeight = (numOfRows: number, dynamicRowHeight: number = 26) => {
  return dynamicRowHeight * numOfRows + 60;
};

export function sendSelectedBlocksToSaveTrade(
  allSelectedNodes: IRowNode[],
  shouldExpand: boolean,
  getAccessTokenSilently: Function,
) {
  // IF FULL BLOCKS ARE SELECTED - CONTIUNE THE TRADE CREATION FLOW.
  // API is only expecting an [] of the ids
  const blockIDsToSend: number[] = [];
  allSelectedNodes?.forEach((node) => {
    if (node.data?.id) {
      blockIDsToSend.push(node.data.id);
    }
  });

  const objToSend = {
    blockIds: blockIDsToSend,
  };

  if (objToSend.blockIds && objToSend.blockIds?.length > 0) {
    if (shouldExpand) {
      saveTradeAction(getAccessTokenSilently, objToSend, true); // true value will set the trade to expand when it is set to the Action summary.
    } else {
      saveTradeAction(getAccessTokenSilently, objToSend, false); // false as the trade will be sent to the action summary without opening the detail.
    }
  } else {
    tradeCreationInProcessStore.getState().setIsTradeCreationBusy(false);
    toast.error("No legs selected.");
  }
}

export function groupPartialBlocksIntoOutgoingObject(
  partiallySelectedNodes: IRowNode[],
  gridRef: React.RefObject<AgGridReact<any>>,
): IblocksRecreateJSONToSend {
  const blocksToSendBack: IRecreateBlock[] = [];
  const existingBlockIDs: number[] = [];

  partiallySelectedNodes.forEach((node) => {
    if (!existingBlockIDs.includes(node.data?.id)) {
      existingBlockIDs.push(node.data.id);

      const detail = gridRef.current?.api.getDetailGridInfo(
        "detail_" + node.data.id,
      );
      const rows = detail?.api?.getSelectedRows();
      const allocationIdsSelected: number[] = [];
      rows?.forEach((row) => allocationIdsSelected.push(row.id));

      const block: IRecreateBlock = {
        id: node.data.id,
        allocations: node.data.allocations.map((allocation: any) => {
          return {
            id: allocation.id,
            include: allocationIdsSelected.includes(allocation.id),
          };
        }),
      };

      blocksToSendBack.push(block);
    }
  });

  const blocksRecreateJSONToSend = {
    blocks: blocksToSendBack,
  };
  return blocksRecreateJSONToSend;
}

export function adjustSelectedStateOfNodesIfNeeded(
  gridRef: React.RefObject<AgGridReact<any>>,
  partiallySelectedNodes: IRowNode[],
) {
  if (partiallySelectedNodes) {
    gridRef.current?.api?.forEachNode((rowNode) => {
      if (rowNode.isSelected() != false) {
        if (rowNode.isSelected() == true) {
        } else {
          //Need to loop through the allocs and loop for situation where none are selected.
          const detail: DetailGridInfo | undefined =
            gridRef.current?.api.getDetailGridInfo("detail_" + rowNode?.id);

          let isOneDetailSelected = false;
          if (detail && detail.api) {
            detail.api.forEachNode((detailNode) => {
              if (detailNode.isSelected()) {
                isOneDetailSelected = true;
              }
            });
          }
          if (!isOneDetailSelected) {
            rowNode.setSelected(false);
          }
          //   if (params.node.isSelected() == true) {
          //     detail.api.selectAll();
          //   } else if (params.node.isSelected() == false) {
          //     detail.api.deselectAll();
          //   }
          // }
          // here can we deselect
          // rowNode.setSelected(false);
        }
      }
    });
  }
}

export function returnFullAndPartialSelectedNodes(
  gridRef: React.RefObject<AgGridReact<any>>,
) {
  const fullySelectedNodes: IRowNode[] = [];
  const partiallySelectedNodes: IRowNode[] = [];

  gridRef.current?.api?.forEachNode((rowNode) => {
    if (rowNode.isSelected() != false) {
      if (rowNode.isSelected() == true) {
        fullySelectedNodes.push(rowNode);
      } else {
        partiallySelectedNodes.push(rowNode);
      }
    }
  });
  return { fullySelectedNodes, partiallySelectedNodes };
}

export function returnTrueIfNodesConatinNotDealt(
  gridRef: React.RefObject<AgGridReact<any>>,
) {
  let containsStatusNotDealt: boolean = false;
  gridRef.current?.api?.forEachNode((rowNode) => {
    if (
      rowNode.isSelected() != false &&
      // rowNode.isSelected() == true && // - Row node will be at a isSelected on Null if it's partially selected.
      rowNode?.data?.status == "Not Dealt"
    ) {
      containsStatusNotDealt = true;
    }
  });
  return containsStatusNotDealt;
}

export function handelCreationTableSelection(
  params: RowSelectedEvent,
  gridRef: React.RefObject<AgGridReact<any>>,
  setCanRecreateBlocks: Dispatch<SetStateAction<boolean>>,
) {
  const detail: DetailGridInfo | undefined = params.api.getDetailGridInfo(
    "detail_" + params.node?.id,
  );
  if (detail && detail.api) {
    if (params.node.isSelected() == true) {
      detail.api.selectAll();
    } else if (params.node.isSelected() == false) {
      detail.api.deselectAll();
    }
  }
  const { partiallySelectedNodes } = returnFullAndPartialSelectedNodes(gridRef);

  if (partiallySelectedNodes && partiallySelectedNodes.length > 0) {
    setCanRecreateBlocks(true);
  } else {
    setCanRecreateBlocks(false);
  }
}

export const splitBlocksFacade = async ({
  getAccessTokenSilently,
  gridRef,
}: {
  getAccessTokenSilently: Function;
  gridRef: React.RefObject<AgGridReact<any>>;
}) => {
  const { partiallySelectedNodes } =
    returnFullAndPartialSelectedNodes(gridRef);

  const blocksToSend = groupPartialBlocksIntoOutgoingObject(
    partiallySelectedNodes,
    gridRef,
  );

  splitBlocksSERVICE(blocksToSend, getAccessTokenSilently);
};

export const blockGridStylesTradeCreation = (
  theme: string | undefined,
  tableStripeOddTrue: boolean,
) => {
  // Get colors from the store
  const creationColorLight = useTableUIStore.getState().creationColorLight;
  const creationColorDark = useTableUIStore.getState().creationColorDark;
  const creationFlashColorLight =
    useTableUIStore.getState().creationFlashColorLight;
  const creationFlashColorDark =
    useTableUIStore.getState().creationFlashColorDark;

  // Helper function to adjust color brightness
  const adjustBrightness = (hex: string, percent: number): string => {
    const num = parseInt(hex.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return (
      "#" +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  };

  if (theme == "light") {
    const baseColor = creationColorLight;
    const stripeColor = tableStripeOddTrue
      ? adjustBrightness(baseColor, -5)
      : baseColor;
    const hoverColor = adjustBrightness(baseColor, -10);

    return {
      "--ag-background-color": baseColor,
      "--ag-odd-row-background-color": stripeColor,
      "--ag-row-hover-color": hoverColor,
      "--ag-value-change-value-highlight-background-color":
        creationFlashColorLight,
    };
  } else {
    // DARK
    const baseColor = creationColorDark;
    const stripeColor = tableStripeOddTrue
      ? adjustBrightness(baseColor, 5)
      : baseColor;
    const hoverColor = adjustBrightness(baseColor, 10);

    return {
      "--ag-background-color": baseColor,
      "--ag-odd-row-background-color": stripeColor,
      "--ag-row-hover-color": hoverColor,
      "--ag-value-change-value-highlight-background-color":
        creationFlashColorDark,
    };
  }
};

// export function allocGridStyles(
//   theme: string | undefined,
//   tableStripeOddTrue: boolean,
// ) {
//   if (theme == "light") {
//     return {
//       "--ag-background-color": "transparent",
//       "--ag-odd-row-background-color": tableStripeOddTrue
//         ? cubeCustomColors.cubeTableRowColour[300]
//         : "transparent",
//       "--ag-row-hover-color": cubeCustomColors.cubeTableRowColour[200], // Hover color
//     };
//   } else {
//     // DARK
//     return {
//       "--ag-background-color": "transparent",
//       "--ag-odd-row-background-color": tableStripeOddTrue
//         ? cubeCustomColors.cubeTableRowColour[500]
//         : "transparent",
//       "--ag-row-hover-color": cubeCustomColors.cubeTableRowColour[400], // Hover color
//     };
//   }
// }

// Right Click Menu for trade creation table
export function getContextMenuItemsTradeCreation(
  params: GetContextMenuItemsParams,
  getAccessTokenSilently: Function,
) {
  if (tradeCreationInProcessStore.getState().isTradeCreationBusy) return ["copy"];

  var result: (string | MenuItemDef)[] = [
    "cut",
    "copy",
    "copyWithHeaders",
    "copyWithGroupHeaders",
    "paste",
    "separator",
    "export",
    "separator",
    {
      name: "Clear Filters",
      icon: clearFilters,
      action: () => {
        clearAllGridFilters(params.api);
      },
    },
    { ...collapseAllExpandedRowsContextMenuObject },
  ];

  // Add / Push Option to the front of the list depending on Status
  if (params.node && params.node.data) {
    const blockId = params.node.data.id;
    const newIssue = params.node.data.newIssue;
    const effectiveDate = params.node.data.effectiveDate;

    const status: "Unassigned" | "Not Dealt" | "Cancelled" =
      params.node.data.status;
    if (status == "Unassigned") {
      // push... "Not Dealt" workflow action - Status to send = "Not Dealt"
      result.unshift("separator");
      result.unshift({
        name: "Not Dealt",
        cssClasses: ["NotDealtActionButtonER"],
        icon: "", //close,
        action: async () => {
          params.node?.setSelected(false);
          tradeCreationInProcessStore.getState().setIsTradeCreationBusy(true);
          try {
            await updateBlockStatusFromContextActions({
              blockIdPassed: blockId,
              statusPassed: "Not Dealt",
              effectiveDate,
              newIssue,
              getAccessTokenSilently,
            });
          } finally {
            tradeCreationInProcessStore.getState().setIsTradeCreationBusy(false);
          }
        },
      });
    } else if (status == "Not Dealt") {
      // push... "Re-Open" workflow action - Status to send = “Unassigned”
      // push... "Cancel " workflow action - Status to send = "Cancelled"
      result.unshift("separator");
      result.unshift({
        name: "Cancel in OMS",
        cssClasses: ["NotDealtActionButtonER"],
        icon: "", //close,
        action: async () => {
          tradeCreationInProcessStore.getState().setIsTradeCreationBusy(true);
          try {
            // Actions new endpoint 'Delete' Designed to remove block and call megaPipe for the updated Trade Creation.
            await deleteBlockFromContextActions({
              blockIdPassed: blockId,
              getAccessTokenSilently,
            });
          } finally {
            tradeCreationInProcessStore.getState().setIsTradeCreationBusy(false);
          }
        },
      });
      result.unshift({
        name: "Re-Open",
        cssClasses: ["NotDealtActionButtonER"],
        icon: "", //close,
        action: async () => {
          tradeCreationInProcessStore.getState().setIsTradeCreationBusy(true);
          try {
            await updateBlockStatusFromContextActions({
              blockIdPassed: blockId,
              statusPassed: "Unassigned",
              effectiveDate,
              newIssue,
              getAccessTokenSilently,
            });
          } finally {
            tradeCreationInProcessStore.getState().setIsTradeCreationBusy(false);
          }
        },
      });
    }
  }

  return result;
}
